import React, { Component } from 'react';
import ErrorPage from './ErrorPage';

export class PageNotFound extends Component {
     render = () => {
          return (
               <ErrorPage type="404" />
          );
     }
}